// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--JnY43";
export var copyright = "Footer-module--copyright--Q+Jzi";
export var disclaimer = "Footer-module--disclaimer--O+99y";
export var pages = "Footer-module--pages--fOnjR";